import * as ambassadorWixEcomV1CheckoutTemplate from './ecom-v1-checkout-template-checkout-templates.http.js';
import * as ambassadorWixEcomV1CheckoutTemplateTypes from './ecom-v1-checkout-template-checkout-templates.types.js';
import * as ambassadorWixEcomV1CheckoutTemplateUniversalTypes from './ecom-v1-checkout-template-checkout-templates.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCheckoutTemplate(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutTemplateResponse,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutTemplateResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.createCheckoutTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout-templates',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCheckoutTemplate(): __PublicMethodMetaInfo<
  'GET',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.GetCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.GetCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.GetCheckoutTemplateResponse,
  ambassadorWixEcomV1CheckoutTemplateTypes.GetCheckoutTemplateResponse
> {
  const payload = { checkoutTemplateId: ':checkoutTemplateId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.getCheckoutTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/checkout-templates/{checkoutTemplateId}',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCheckoutTemplate(): __PublicMethodMetaInfo<
  'PATCH',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.UpdateCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.UpdateCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.UpdateCheckoutTemplateResponse,
  ambassadorWixEcomV1CheckoutTemplateTypes.UpdateCheckoutTemplateResponse
> {
  const payload = { checkoutTemplate: { id: ':checkoutTemplateId' } } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.updateCheckoutTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/checkout-templates/{checkoutTemplate.id}',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCheckoutTemplate(): __PublicMethodMetaInfo<
  'DELETE',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.DeleteCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.DeleteCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.DeleteCheckoutTemplateResponse,
  ambassadorWixEcomV1CheckoutTemplateTypes.DeleteCheckoutTemplateResponse
> {
  const payload = { checkoutTemplateId: ':checkoutTemplateId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.deleteCheckoutTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/checkout-templates/{checkoutTemplateId}',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCheckoutTemplates(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.QueryCheckoutTemplatesRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.QueryCheckoutTemplatesRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.QueryCheckoutTemplatesResponse,
  ambassadorWixEcomV1CheckoutTemplateTypes.QueryCheckoutTemplatesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.queryCheckoutTemplates(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout-templates/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createCheckoutFromTemplate(): __PublicMethodMetaInfo<
  'POST',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutFromTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutFromTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutFromTemplateResponse,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutFromTemplateResponse
> {
  const payload = { checkoutTemplateId: ':checkoutTemplateId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.createCheckoutFromTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout-templates/{checkoutTemplateId}/create-checkout-from-template',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createAndRedirectToCheckout(): __PublicMethodMetaInfo<
  'GET',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateAndRedirectToCheckoutRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateAndRedirectToCheckoutRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.RawHttpResponse,
  ambassadorWixEcomV1CheckoutTemplateTypes.RawHttpResponse
> {
  const payload = { checkoutTemplateId: ':checkoutTemplateId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.createAndRedirectToCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/checkout-templates/{checkoutTemplateId}/create-and-redirect-to-checkout',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CheckoutTemplate as CheckoutTemplateOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  CheckoutCustomization as CheckoutCustomizationOriginal,
  WebClientCustomization as WebClientCustomizationOriginal,
  V1LineItem as V1LineItemOriginal,
  CatalogReference as CatalogReferenceOriginal,
  CatalogOverrideFields as CatalogOverrideFieldsOriginal,
  ProductName as ProductNameOriginal,
  DescriptionLine as DescriptionLineOriginal,
  DescriptionLineValueOneOf as DescriptionLineValueOneOfOriginal,
  DescriptionLineDescriptionLineValueOneOf as DescriptionLineDescriptionLineValueOneOfOriginal,
  DescriptionLineName as DescriptionLineNameOriginal,
  PlainTextValue as PlainTextValueOriginal,
  Color as ColorOriginal,
  DescriptionLineType as DescriptionLineTypeOriginal,
  DescriptionLineTypeWithLiterals as DescriptionLineTypeWithLiteralsOriginal,
  PhysicalProperties as PhysicalPropertiesOriginal,
  Dimensions as DimensionsOriginal,
  DimensionsUnit as DimensionsUnitOriginal,
  DimensionsUnitWithLiterals as DimensionsUnitWithLiteralsOriginal,
  Image as ImageOriginal,
  PaymentOption as PaymentOptionOriginal,
  PaymentOptionType as PaymentOptionTypeOriginal,
  PaymentOptionTypeWithLiterals as PaymentOptionTypeWithLiteralsOriginal,
  CustomLineItem as CustomLineItemOriginal,
  PriceDescription as PriceDescriptionOriginal,
  PageUrlV2 as PageUrlV2Original,
  ItemType as ItemTypeOriginal,
  ItemTypeItemTypeDataOneOf as ItemTypeItemTypeDataOneOfOriginal,
  ItemTypePreset as ItemTypePresetOriginal,
  ItemTypePresetWithLiterals as ItemTypePresetWithLiteralsOriginal,
  SubscriptionOptionInfo as SubscriptionOptionInfoOriginal,
  SubscriptionSettings as SubscriptionSettingsOriginal,
  SubscriptionFrequency as SubscriptionFrequencyOriginal,
  SubscriptionFrequencyWithLiterals as SubscriptionFrequencyWithLiteralsOriginal,
  FreeTrialPeriod as FreeTrialPeriodOriginal,
  BillingSettings as BillingSettingsOriginal,
  Title as TitleOriginal,
  Description as DescriptionOriginal,
  SecuredMedia as SecuredMediaOriginal,
  FileType as FileTypeOriginal,
  FileTypeWithLiterals as FileTypeWithLiteralsOriginal,
  ServiceProperties as ServicePropertiesOriginal,
  Policy as PolicyOriginal,
  TaxableAddress as TaxableAddressOriginal,
  TaxableAddressTaxableAddressDataOneOf as TaxableAddressTaxableAddressDataOneOfOriginal,
  TaxableAddressType as TaxableAddressTypeOriginal,
  TaxableAddressTypeWithLiterals as TaxableAddressTypeWithLiteralsOriginal,
  V1ModifierGroup as V1ModifierGroupOriginal,
  TranslatableString as TranslatableStringOriginal,
  V1ItemModifier as V1ItemModifierOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CustomContentReference as CustomContentReferenceOriginal,
  ExternalReference as ExternalReferenceOriginal,
  CheckoutTemplateUsed as CheckoutTemplateUsedOriginal,
  Checkout as CheckoutOriginal,
  LineItem as LineItemOriginal,
  MultiCurrencyPrice as MultiCurrencyPriceOriginal,
  ItemTaxFullDetails as ItemTaxFullDetailsOriginal,
  TaxRateBreakdown as TaxRateBreakdownOriginal,
  TaxBreakdown as TaxBreakdownOriginal,
  JurisdictionType as JurisdictionTypeOriginal,
  JurisdictionTypeWithLiterals as JurisdictionTypeWithLiteralsOriginal,
  CommonImage as CommonImageOriginal,
  FocalPoint as FocalPointOriginal,
  ItemAvailabilityInfo as ItemAvailabilityInfoOriginal,
  ItemAvailabilityStatus as ItemAvailabilityStatusOriginal,
  ItemAvailabilityStatusWithLiterals as ItemAvailabilityStatusWithLiteralsOriginal,
  Scope as ScopeOriginal,
  Group as GroupOriginal,
  ModifierGroup as ModifierGroupOriginal,
  ItemModifier as ItemModifierOriginal,
  PlatformFee as PlatformFeeOriginal,
  PlatformFeeChargeType as PlatformFeeChargeTypeOriginal,
  PlatformFeeChargeTypeWithLiterals as PlatformFeeChargeTypeWithLiteralsOriginal,
  AddressWithContact as AddressWithContactOriginal,
  Address as AddressOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  FullAddressContactDetails as FullAddressContactDetailsOriginal,
  VatId as VatIdOriginal,
  VatType as VatTypeOriginal,
  VatTypeWithLiterals as VatTypeWithLiteralsOriginal,
  ShippingInfo as ShippingInfoOriginal,
  SelectedCarrierServiceOption as SelectedCarrierServiceOptionOriginal,
  DeliveryLogistics as DeliveryLogisticsOriginal,
  PickupDetails as PickupDetailsOriginal,
  PickupMethod as PickupMethodOriginal,
  PickupMethodWithLiterals as PickupMethodWithLiteralsOriginal,
  DeliveryTimeSlot as DeliveryTimeSlotOriginal,
  SelectedCarrierServiceOptionPrices as SelectedCarrierServiceOptionPricesOriginal,
  SelectedCarrierServiceOptionOtherCharge as SelectedCarrierServiceOptionOtherChargeOriginal,
  ChargeType as ChargeTypeOriginal,
  ChargeTypeWithLiterals as ChargeTypeWithLiteralsOriginal,
  DeliveryAllocation as DeliveryAllocationOriginal,
  Carrier as CarrierOriginal,
  Region as RegionOriginal,
  ApplicableLineItems as ApplicableLineItemsOriginal,
  ShippingRegion as ShippingRegionOriginal,
  CarrierServiceOption as CarrierServiceOptionOriginal,
  ShippingOption as ShippingOptionOriginal,
  ShippingPrice as ShippingPriceOriginal,
  OtherCharge as OtherChargeOriginal,
  BuyerInfo as BuyerInfoOriginal,
  BuyerInfoIdOneOf as BuyerInfoIdOneOfOriginal,
  PriceSummary as PriceSummaryOriginal,
  CalculationErrors as CalculationErrorsOriginal,
  CalculationErrorsShippingCalculationErrorOneOf as CalculationErrorsShippingCalculationErrorOneOfOriginal,
  Details as DetailsOriginal,
  DetailsKindOneOf as DetailsKindOneOfOriginal,
  ApplicationError as ApplicationErrorOriginal,
  ValidationError as ValidationErrorOriginal,
  RuleType as RuleTypeOriginal,
  RuleTypeWithLiterals as RuleTypeWithLiteralsOriginal,
  FieldViolation as FieldViolationOriginal,
  SystemError as SystemErrorOriginal,
  CarrierErrors as CarrierErrorsOriginal,
  CarrierError as CarrierErrorOriginal,
  GiftCardCalculationError as GiftCardCalculationErrorOriginal,
  GiftCard as GiftCardOriginal,
  AppliedDiscount as AppliedDiscountOriginal,
  AppliedDiscountDiscountSourceOneOf as AppliedDiscountDiscountSourceOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  Coupon as CouponOriginal,
  MerchantDiscount as MerchantDiscountOriginal,
  DiscountRule as DiscountRuleOriginal,
  DiscountRuleName as DiscountRuleNameOriginal,
  LineItemDiscount as LineItemDiscountOriginal,
  ItemCombination as ItemCombinationOriginal,
  ItemCombinationLineItem as ItemCombinationLineItemOriginal,
  CustomField as CustomFieldOriginal,
  WeightUnit as WeightUnitOriginal,
  WeightUnitWithLiterals as WeightUnitWithLiteralsOriginal,
  TaxSummary as TaxSummaryOriginal,
  TaxCalculationDetails as TaxCalculationDetailsOriginal,
  TaxCalculationDetailsCalculationDetailsOneOf as TaxCalculationDetailsCalculationDetailsOneOfOriginal,
  RateType as RateTypeOriginal,
  RateTypeWithLiterals as RateTypeWithLiteralsOriginal,
  ManualCalculationReason as ManualCalculationReasonOriginal,
  ManualCalculationReasonWithLiterals as ManualCalculationReasonWithLiteralsOriginal,
  AutoTaxFallbackCalculationDetails as AutoTaxFallbackCalculationDetailsOriginal,
  FallbackReason as FallbackReasonOriginal,
  FallbackReasonWithLiterals as FallbackReasonWithLiteralsOriginal,
  AggregatedTaxBreakdown as AggregatedTaxBreakdownOriginal,
  ChannelType as ChannelTypeOriginal,
  ChannelTypeWithLiterals as ChannelTypeWithLiteralsOriginal,
  CreatedBy as CreatedByOriginal,
  CreatedByIdOneOf as CreatedByIdOneOfOriginal,
  MembershipOptions as MembershipOptionsOriginal,
  Membership as MembershipOriginal,
  MembershipName as MembershipNameOriginal,
  MembershipPaymentCredits as MembershipPaymentCreditsOriginal,
  BalanceType as BalanceTypeOriginal,
  BalanceTypeWithLiterals as BalanceTypeWithLiteralsOriginal,
  InvalidMembership as InvalidMembershipOriginal,
  SelectedMemberships as SelectedMembershipsOriginal,
  SelectedMembership as SelectedMembershipOriginal,
  AdditionalFee as AdditionalFeeOriginal,
  AdditionalFeeSource as AdditionalFeeSourceOriginal,
  AdditionalFeeSourceWithLiterals as AdditionalFeeSourceWithLiteralsOriginal,
  ConversionInfo as ConversionInfoOriginal,
  Violation as ViolationOriginal,
  Severity as SeverityOriginal,
  SeverityWithLiterals as SeverityWithLiteralsOriginal,
  Target as TargetOriginal,
  TargetTargetTypeOneOf as TargetTargetTypeOneOfOriginal,
  NameInOther as NameInOtherOriginal,
  NameInOtherWithLiterals as NameInOtherWithLiteralsOriginal,
  NameInLineItem as NameInLineItemOriginal,
  NameInLineItemWithLiterals as NameInLineItemWithLiteralsOriginal,
  SuggestedFix as SuggestedFixOriginal,
  SuggestedFixWithLiterals as SuggestedFixWithLiteralsOriginal,
  Other as OtherOriginal,
  TargetLineItem as TargetLineItemOriginal,
  CustomSettings as CustomSettingsOriginal,
  SubscriptionCharges as SubscriptionChargesOriginal,
  Charge as ChargeOriginal,
  CreateCheckoutTemplateRequest as CreateCheckoutTemplateRequestOriginal,
  CreateCheckoutTemplateResponse as CreateCheckoutTemplateResponseOriginal,
  GetCheckoutTemplateRequest as GetCheckoutTemplateRequestOriginal,
  GetCheckoutTemplateResponse as GetCheckoutTemplateResponseOriginal,
  UpdateCheckoutTemplateRequest as UpdateCheckoutTemplateRequestOriginal,
  UpdateCheckoutTemplateResponse as UpdateCheckoutTemplateResponseOriginal,
  DeleteCheckoutTemplateRequest as DeleteCheckoutTemplateRequestOriginal,
  DeleteCheckoutTemplateResponse as DeleteCheckoutTemplateResponseOriginal,
  QueryCheckoutTemplatesRequest as QueryCheckoutTemplatesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryCheckoutTemplatesResponse as QueryCheckoutTemplatesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  CreateCheckoutFromTemplateRequest as CreateCheckoutFromTemplateRequestOriginal,
  CreateCheckoutFromTemplateResponse as CreateCheckoutFromTemplateResponseOriginal,
  CreateAndRedirectToCheckoutRequest as CreateAndRedirectToCheckoutRequestOriginal,
  RawHttpResponse as RawHttpResponseOriginal,
  HeadersEntry as HeadersEntryOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateCheckoutTemplateApplicationErrors as CreateCheckoutTemplateApplicationErrorsOriginal,
  UpdateCheckoutTemplateApplicationErrors as UpdateCheckoutTemplateApplicationErrorsOriginal,
  CreateCheckoutFromTemplateApplicationErrors as CreateCheckoutFromTemplateApplicationErrorsOriginal,
  CreateAndRedirectToCheckoutApplicationErrors as CreateAndRedirectToCheckoutApplicationErrorsOriginal,
} from './ecom-v1-checkout-template-checkout-templates.types.js';
